export const colors = {
    white: 'white',
    green: '#b3c135',
    orange: '#e47425',
    blue: '#00586f'
}

export const pattern = () => {
    return (`
        background-image: url('/images/background-pattern.jpg');
        background-position: center center;
        position: relative;
    `)
}

export const transition = '.2s';

require("typeface-roboto")
require("typeface-lato")

export const padding = '2rem';

export const fonts = {
    raleway: () => {
        return `
            font-family: 'Raleway', sans-serif;
            font-weight: 300;
        `;
    },

    lato: () => {
        return `
            font-family: 'Lato', sans-serif;
            font-weight: 400;
        `;
    }
}

export const breakPoints = {
    large: 1200,
    tablet: 768,
    phone: 480, 
}

export const breaks = {
    phone: (styles) => {
        return `
            @media (min-width: ${breakPoints.phone}px) {
                ${styles}
            }
        `
    },
    
    tablet: (styles) => {
        return `
            @media (min-width: ${breakPoints.tablet}px) {
                ${styles}
            }
        `
    },
    
    desktop: (styles) => {
        return `
            @media (min-width: ${breakPoints.large}px) {
                ${styles}
            }
        `
    }
}